// import { isIntlSite } from '@src/global-components/layout/const';

import { isIntlSite } from '@src/global-components/layout/const';
import queryString from 'query-string';

export const getBaseLang = () => {
  // if (!isIntlSite) return 'zh';

  const parsed = queryString.parse(location.search);
  const initLang = parsed.lang as string;
  const baseLang = initLang ? initLang : localStorage.getItem('lang') || '';
  const langList = ['zh', 'en'];
  const defaultLanguage = isIntlSite ? 'en' : 'zh';
  const webLanguage: string =
    navigator?.language?.split('-')?.[0] ?? defaultLanguage;
  const language = langList.includes(webLanguage)
    ? webLanguage
    : defaultLanguage;
  if (langList.includes(baseLang)) {
    return baseLang;
  }
  return language;
};
